import axios from 'axios'
import Cookie from 'js-cookie'
import { getSign } from '@didi/wsgsig';

const envConfig = {
  production: '/api/mall',
  // testing: 'http://api-kylin-xg02.intra.xiaojukeji.com/InternalPlatform_WaiBao_functional_online_meal_shiyu_api_mall_oetest_dev/api/mall',
  testing: 'http://shiyu-test.intra.xiaojukeji.com/api/mall',
  stage: 'http://[stage]/mall',
  development: '/api/mall'
}

export const baseURL = envConfig[process.env.NODE_ENV || 'development']
export const API_PREFIX = baseURL.indexOf('http') >= 0 ? baseURL : `${location.origin}${baseURL}` 
export const HTTP = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    common: {
      'X-Requested-With': 'XMLHttpRequest',
      'token': Cookie.get('mall_token'),
      "csrfToken": Cookie.get('mall_cs_token')
    },
    post: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
})

HTTP.interceptors.request.use(function (config) {
  config.headers.csrfToken = Cookie.get('mall_cs_token');
  let wsgsigList = ['/user/query', '/order/setCartToConformOrder'];
  let formatUrl = config.url
  if (wsgsigList.includes(formatUrl)) {
    let funObj = {
      contentType: 'application/json'
    };
    if (config.method === 'post') {
      funObj.body = config.data || {}
    } else {
      funObj.params = config.params || {}
    }
    const sign = getSign(funObj);
    config['headers']['wsgsig'] = sign;
  }
  return config;
}, function (error) {
  console.log(error)
  return Promise.reject(error);
});

// 请求后的钩子函数
HTTP.interceptors.response.use(function (response) {
  // console.log(response)
  return response;
}, function (error) {
  console.log(error)
})





// WEBPACK FOOTER //
// ./src/util/axios.js